import { updateDosespotClinician } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  UpdateDosespotClinicianRequestT,
  DosespotClinicianRecordT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

/**
 * Update DoseSpot clinician record for the specified user.
 */
export async function fetchUpdateDosespotClinician(
  userId: string,
  data: UpdateDosespotClinicianRequestT,
  signal?: AbortSignal
): Promise<DosespotClinicianRecordT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await updateDosespotClinician(userId, data, config);
  return lotusHealthZod.updateDosespotClinicianResponse.parse(
    response.data
  ) as DosespotClinicianRecordT;
}
